import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import { history } from 'containers/App';

import ErrorPage from 'components/Errors/ErrorPage';

const ServiceUnavailableError = ({ intl }) => <ErrorPage title={ intl.formatMessage({ id: 'serviceUnavailablePage.title' }) } type="server" showButton onButtonClick={ () => history.go(-1) }>
  <FormattedHTMLMessage id="serviceUnavailablePage.content" />
</ErrorPage>;

ServiceUnavailableError.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  history: PropTypes.shape({
    go: PropTypes.func,
  }).isRequired
};

export default injectIntl(ServiceUnavailableError);
